import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { privacyAgreeApi } from "./../api/privacyAgreeApi";
import {
  initState,
  submitData,
} from "../../../../modules/reducers/agreePrivacyTerm/agreePrivacy";

const usePrivacyAgree = () => {
  const dispatch = useDispatch();
  const api = privacyAgreeApi();
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(" ", "+");
  const status = useSelector((state) => state.agreePrivacy.status);

  const loading = useSelector((state) => state.agreePrivacy.loading);

  const navigate = useNavigate();

  const submit = () => {
    const data = {
      service_name: "CHATBOT_VOC",
      user_id: userId,
    };
    dispatch(submitData({ ...api, data }));
  };

  useEffect(() => {
    if (status === true) {
      dispatch(initState());
      navigate("/service-unavailable/contact-us");
    }
  }, [status]);
  return { submit, loading };
};

export default usePrivacyAgree;
